import React, { useMemo, useState } from 'react'
import moment from 'moment'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useRegisterBreadcrumbAction } from 'components/AuthenticatedLayout/Header/components/BreadcrumbActions'

import HeaderExportButton from 'components/global/Buttons/HeaderExportButton'
import Status, { Types, Verbatim } from './Filters'
import Table from './Table'
import useCDRs from './use-cdrs'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'
import DateFilter from '../../../components/DateFilter'

const Export = ({ onExport }) => {
  const { t } = useTranslation()

  const handleExport = () => {
    const content = onExport()
    const encodedUri = encodeURI(content)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `cdrs_${new Date().toLocaleDateString()}`)
    document.body.appendChild(link)// Required for FF

    link.click();
    document.body.removeChild(link)
  }
  return (
    <HeaderExportButton
      analyticsName="voip_cdrs"
      onClick={handleExport}
    >
      {t('export.button')}
    </HeaderExportButton>
  )
}
const CDRs: React.FC = () => {
  const [filters, setFilters] = useState({
    statuses: [],
    types: [],
    verbatim: '',
    startAt: moment().startOf('day'),
    endAt: moment().endOf('day'),
  })
  const {
    loading,
    cdrs,
    statuses,
    types,
    fetchNextPage,
    shouldFetchNextPage,
    onPageReset,
    onExport
  } = useCDRs({ filters })
  const exportAction = useMemo(() => <Export onExport={onExport} />, [onExport])

  useRegisterBreadcrumbAction(exportAction)

  return (
    <Stack spacing={2}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Stack direction={'row'} alignItems={'center'}>
          <Stack direction={'row'} gap={1} height={'100%'}>

            <Status values={filters.statuses} statuses={statuses} onChange={(values) => setFilters(prev => ({ ...prev, statuses: values }))} />
            <Types values={filters.types} types={types} onChange={(values) => setFilters(prev => ({ ...prev, types: values }))} />
            <Verbatim value={filters.verbatim} onChange={(value) => setFilters(prev => ({ ...prev, verbatim: value }))} />
            <DateFilter
              inputSx={{
                width: 230
              }}
              onReset={() => {
                setFilters(prev => ({
                  ...prev,
                  startAt: moment().startOf('day'),
                  endAt: moment().endOf('day'),
                }))
              }}
              startDate={filters.startAt ? filters.startAt.toDate() : null}
              endDate={filters.endAt ? filters.endAt.toDate() : null}
              onSubmit={(startAt, endAt) => {
                setFilters(prev => ({
                  ...prev,
                  startAt: startAt ? moment(startAt) : moment().startOf('day'),
                  endAt: endAt ? moment(endAt) : moment().endOf('day')
                }))
              }}
              placeholderKey={'stats.traffic.date_filter'}
            />
          </Stack>
        </Stack>
      </Stack>
      {loading ? (
        <TableSkeleton />
      ) : (
        <Table
          cdrs={cdrs}
          loading={loading}
          shouldFetchNextPage={shouldFetchNextPage}
          fetchNextPage={fetchNextPage}
          onPageReset={onPageReset}
        />
      )}
    </Stack>
  )
}

export default CDRs